import React from "react";
import { Modal, Row, Col } from "antd";
import { getCarName, formatRupiah } from "../../../../Utils";
import _ from "lodash";

const RowForm = props => (
  <Row style={{ padding: " 5px 10px" }}>{props.children}</Row>
);

class ModalSendToMobbi extends React.Component {
  state = {
    modalSendToMobbi: false,
  };

  render() {
    const { data } = this.props;
    const { Appraisal } = data;
    let carName,
      Booking,
      SalesProfile,
      SalesBranch,
      Supervisor,
      Appraiser,
      licensePlate;

    if (Appraisal) {
      carName = getCarName(Appraisal.carDetail);
      Appraiser = Appraisal.Appraiser;
      Booking = Appraisal.Booking;
      licensePlate = Appraisal.licensePlate;
      if (Booking) {
        SalesProfile = Booking.SalesProfile;
        if (SalesProfile) {
          SalesBranch = SalesProfile.SalesBranch;
          Supervisor = SalesProfile.Supervisor;
        }
      }
    }
    let mobbiId = _.get(data, "Appraisal.Booking.MobbiPayload.mobbiId");
    return (
      <Modal
        title="Data Send To Mobbi"
        visible={this.props.visible}
        confirmLoading={this.props.confirmLoading}
        onOk={() => this.setState({ modalSendToMobbi: true })}
        onCancel={() => this.props.visibleModal(false, data)}
        okText="Confirm"
        width={700}>
        <p>Detail Approval</p>

        <RowForm>
          <Col span={8}>Mobbi Id</Col>
          <Col span={16}>: {mobbiId || ""}</Col>
        </RowForm>
        <RowForm>
          <Col span={8}>No Booking</Col>
          <Col span={16}>: {Booking ? Booking.noBooking : null}</Col>
        </RowForm>
        <RowForm>
          <Col span={8}>Cabang</Col>
          <Col span={16}>: {SalesBranch ? SalesBranch.branch : null}</Col>
        </RowForm>
        <RowForm>
          <Col span={8}>Kepala Cabang</Col>
          <Col span={16}>
            :{" "}
            {SalesBranch
              ? SalesBranch.Kacab
                ? SalesBranch.Kacab.name
                : null
              : null}
          </Col>
        </RowForm>
        <RowForm>
          <Col span={8}>Nama Supervisor</Col>
          <Col span={16}>: {Supervisor ? Supervisor.name : null}</Col>
        </RowForm>
        <RowForm>
          <Col span={8}>Nama Sales</Col>
          <Col span={16}>: {SalesProfile ? SalesProfile.name : null}</Col>
        </RowForm>
        <RowForm>
          <Col span={8}>Nama Appraiser</Col>
          <Col span={16}>: {Appraiser ? Appraiser.name : null}</Col>
        </RowForm>
        <RowForm>
          <Col span={8}>Nama Mobil</Col>
          <Col span={16}>: {carName}</Col>
        </RowForm>
        <RowForm>
          <Col span={8}>Nomor Polisi</Col>
          <Col span={16}>: {licensePlate || null}</Col>
        </RowForm>

        {/* Modal Confirm */}
        <Modal
          title="Konfirmasi"
          visible={this.state.modalSendToMobbi}
          onOk={() =>
            this.setState({ modalSendToMobbi: false }, () =>
              this.props.sendButton(data)
            )
          }
          onCancel={() => this.setState({ modalSendToMobbi: false })}
          okText="Submit"
          width={400}>
          Apakah anda yakin mengirim ke Mobbi?
        </Modal>
      </Modal>
    );
  }
}

export default ModalSendToMobbi;



// WEBPACK FOOTER //
// src/components/Dashboard/Approval/Component/Modal/ModalSendToMobbi.js